import {
  FDBox, FDContentContainer,
  FDLabelText, FDSecondaryActionButton, FDStack,
} from '@facet-wealth/design';
import React, { useCallback } from 'react';
import TaxStrategyGroup
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Content/TabTemplatePicker/TaxStrategy/TaxStrategyGroup';
import TaxStrategyMetaOverride
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Content/TabTemplatePicker/TaxStrategy/TaxStrategyMetaOverrideSet';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import {
  useTabContentContext,
} from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Context';
import TaxStrategyInternalNotes
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Content/TabTemplatePicker/TaxStrategy/TaxStrategyInternalNotes';
import PropTypes from 'prop-types';
import { dataAttrs } from 'Helpers/Testing';

const TaxStrategyReviewTabColumnLabels = () => {
  return (
    <FDStack direction={'row'}>
      <FDBox width={'550px'} />
      <FDBox width={'200px'}>
        <FDLabelText value={'Notes'} />
      </FDBox>
      <FDBox width={'200px'}>
        <FDLabelText value={'Status'} />
      </FDBox>
    </FDStack>
  );
};

const TaxStrategyReviewTabLayout = ({ onSubmit }) => {
  const { activeTabResource, setActiveTabResource } = useTabContentContext();
  const resource = activeTabResource.attr('reviewTab').resources().head();

  const theme = useTheme();
  const markAllItemsAsDoNotShow = useCallback(async () => {
    for (let i = 0; i < resource.attr('groups').resources().length(); i++) {
      for (let j = 0; j < resource.attr('groups').resources().index(i).attr('items')
        .resources()
        .length(); j++) {
        resource.attr('groups').resources().index(i).attr('items')
          .resources()
          .index(j)
          .attr('value', 'doNotShow');
      }
    }
    await onSubmit();
    setActiveTabResource(activeTabResource);
  }, [resource]);

  return (
    <FDStack direction={'row'} spacing={3} flexGrow={1}>
      <FDContentContainer maxWidth={'lg'} flexGrow={1}>
        <FDStack direction={'column'} spacing={3}>
          <MetaControl attrName={'title'} resource={resource} metaOverrideSet={TaxStrategyMetaOverride} />
          <MetaControl attrName={'subtitle'} resource={resource} metaOverrideSet={TaxStrategyMetaOverride} />
          <FDStack direction={'row'}>
            <FDSecondaryActionButton
              {...dataAttrs('tax-strategy-items-mark-all-as-do-not-show-btn')}
              label={'Mark all items as do not show'}
              onClick={markAllItemsAsDoNotShow}
            />
          </FDStack>
          <TaxStrategyReviewTabColumnLabels />
          <FDBox>
            { resource.attr('groups').resources().list().map((group) => {
              return (
                <FDStack direction={'column'}>
                  <TaxStrategyGroup key={group.id()} groupResource={group} itemStatusCollection={resource.attr('itemStatuses')} onSubmit={onSubmit} />
                  <hr
                    style={{
                      border: 'none', height: '1px', margin: `${theme.spacing(4)}px ${theme.spacing(0)}px`, backgroundColor: `${theme.palette.facet.lightGray2}`, width: '100%',
                    }}
                  />
                </FDStack>
              );
            })}
          </FDBox>
        </FDStack>
      </FDContentContainer>
      <TaxStrategyInternalNotes onSubmit={onSubmit} />
    </FDStack>
  );
};

TaxStrategyReviewTabLayout.defaultProps = {
  onSubmit: () => {},
};

TaxStrategyReviewTabLayout.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default TaxStrategyReviewTabLayout;
